var React = require('react');

function Confronta (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"currentColor","d":"M481.044,382.5c0-6.8-5.5-12.3-12.3-12.3h-418.7l73.6-73.6c4.8-4.8,4.8-12.5,0-17.3c-4.8-4.8-12.5-4.8-17.3,0l-94.5,94.5\n\t\tc-4.8,4.8-4.8,12.5,0,17.3l94.5,94.5c2.4,2.4,5.5,3.6,8.7,3.6s6.3-1.2,8.7-3.6c4.8-4.8,4.8-12.5,0-17.3l-73.6-73.6h418.8\n\t\tC475.544,394.7,481.044,389.3,481.044,382.5z","key":0}),React.createElement("path",{"fill":"currentColor","d":"M477.444,98l-94.5-94.4c-4.8-4.8-12.5-4.8-17.3,0s-4.8,12.5,0,17.3l73.6,73.6h-418.8c-6.8,0-12.3,5.5-12.3,12.3\n\t\ts5.5,12.3,12.3,12.3h418.8l-73.6,73.4c-4.8,4.8-4.8,12.5,0,17.3c2.4,2.4,5.5,3.6,8.7,3.6s6.3-1.2,8.7-3.6l94.5-94.5\n\t\t\tC482.244,110.6,482.244,102.8,477.444,98z","key":1})]);
}

Confronta.defaultProps = {"version":"1.1","viewBox":"0 0 489.2 489.2","xmlSpace":"preserve"};

module.exports = Confronta;

Confronta.default = Confronta;
